import styled from "styled-components";
import { Row, Col, Card } from "react-bootstrap";
import { ContainerFrame, FooterSection, ArticleSuggest } from "@components";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { NewsDetailAPI } from "@api";
import moment from "moment";
import { useTranslation } from "react-i18next";

moment.locale("id");

const Container = styled.div`
  padding-top: 56px;
  overflow: hidden;
`;

const Title = styled.div`
  font-size: 1.8em;
  color: #85714d;
  font-weight: bold;
`;

const Subtitle = styled.div`
  color: #8a8d8f;
`;

const Link = styled.span`
  color: #f2a900;
`;

const ArticleBox = styled.div`
  display: grid;
  row-gap: 14px;
`;

const ArticleDetail2 = function () {
  const { t } = useTranslation();
  let { slug } = useParams();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    const loadArticle = async () => {
      const { data } = await NewsDetailAPI({ slug });
      setArticle({
        ...data.data,
        ...{
          created_at: moment(data.data["created_at"], "DD-MM-YYYY hh:mm:ss").format("DD MMMM YYYY"),
          description: data.data.description && data.data.description.split('src="/').join('src="https://bukopin.seasalt.dev/')               
        },
      });
    };

    if (article === null) {
      loadArticle();
    }
  }, [article, slug]);

  return (
    <Container>
      <ContainerFrame className="text-start py-5">
        <Row>
          <Col xs={12} md={9}>
            <div>
              <Title>{article !== null ? article.title : ""}</Title>
              <Subtitle>
                {t("oleh")} <Link>{t("bank_kb_bukopin")}</Link> {t("di")} <Link>{t("press_releases_and_announcements")}</Link>
              </Subtitle>
              <div className="text-end pb-2 text-secondary pt-2">
                {article !== null ? article.created_at : ""}
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: article != null ? article.description : "",
                }}
              ></div>
            </div>
          </Col>
          <Col xs={12} md={3} className="pt-4">
            <Card className="p-3" style={{ background: "transparent" }}>
              <div>
                <div className="col-12 mb-2 d-flex justify-content-start align-items-center">
                  <div className="fw-bold color-brown">{t("siaran_pers_lainnya")}</div>
                </div>
                <ArticleBox>
                <ArticleSuggest
                    title={article !== null ? article.related[0].title:""}
                    subtitle={article !== null ? article.related[0].description:""}
                    slug={article !== null ? article.related[0].slug:""}
                    type="pressconference"
                  />
                  <ArticleSuggest
                    title={article !== null ? article.related[1].title:""}
                    subtitle={article !== null ? article.related[1].description:""}
                    slug={article !== null ? article.related[1].slug:""}
                    type="pressconference"
                  />
                  <ArticleSuggest
                    title={article !== null ? article.related[2].title:""}
                    subtitle={article !== null ? article.related[2].description:""}
                    slug={article !== null ? article.related[2].slug:""}
                    type="pressconference"
                  />
                  <ArticleSuggest
                    title={article !== null ? article.related[3].title:""}
                    subtitle={article !== null ? article.related[3].description:""}
                    slug={article !== null ? article.related[3].slug:""}
                    type="pressconference"
                  />
                </ArticleBox>
              </div>
            </Card>
          </Col>
        </Row>
      </ContainerFrame>

      <FooterSection currentPage={t("detail_artikel")} />
    </Container>
  );
};

export default ArticleDetail2;
